import * as yup from 'yup'
import { translate as t } from '../../../i18n'

export const routineSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required(() => t('general.validator.empty')),
  type: yup
    .string()
    .required(() => t('general.validator.option')),
  level: yup
    .string()
    .required(() => t('general.validator.option')),
  note: yup
    .string()
    .default('')
    .nullable(),
  labels: yup
    .array(
      yup.object({
        name: yup.string(),
        id: yup.string()
      })
    )
    .default([])
    .nullable()
})
